import Entity from "./entity";
import Mass from "./mass";
import Health from "./health";
import Speed from "./speed";
import Quips from "./quips";
import Behaviour from "./behaviour";

const Forager = new Behaviour({
  initial: "Resting",
  states: {
    Resting: {
      wakeup: "Idling"
    },
    Idling: {
      hungry: "Foraging",
      tired: "Resting"
    },
    Foraging: {
      sated: "Idling",
      tired: "Resting"
    }
  }
});

const Worker = new Behaviour({
  initial: "Tending",
  states: {
    Tending: {
      seek: "Seeking"
    },
    Seeking: {
      tend: "Tending"
    }
  },
  context: {
    Tending: { tiles: ["Garden"] },
    Seeking: { targets: [{x: 277, y: 270}, {x: 271, y: 285}]}
  }
});

class WorkerSense {
  constructor() {
    this.behaviour = Worker;
  }

  isEnemy() {
    return false;
  }

  seek() {
    this.behaviour.transition("seek");
  }

  tend() {
    this.behaviour.transition("tend");
  }

  takeTurn(stage) {
    this.behaviour.execute(this.owner, stage);
    return true;
  }
}

class BystanderSense {
  constructor() {
    this.behaviour = Forager;
    this.fatigue = 0;
    this.hunger = 0;
  }

  isEnemy() {
    return false;
  }

  decreaseFatigue(value=1) {
    if (value > 0) this.fatigue -= value;
  }

  increaseFatigue(value=1) {
    if (value > 0) this.fatigue += value;
  }

  isTired() {
    return this.fatigue >= 20;
  }

  isRested() {
    return this.fatigue <= 0;
  }

  decreaseHunger(value=1) {
    if (value > 0) this.hunger -= value;
  }

  increaseHunger(value=1) {
    if (value > 0) this.hunger += value;
  }

  isHungry() {
    return this.fatigue >= 12;
  }

  isSated() {
    return this.fatigue <= 5;
  }

  wakeup() {
    this.behaviour.transition("wakeup");
  }

  hungry() {
    this.behaviour.transition("hungry");   
  }

  tired() {
    this.behaviour.transition("tired");   
  }

  sated() {
    this.behaviour.transition("sated");   
  }

  wasBumped(stage) {
    if (this.behaviour.canTransition("wakeup")) {
      this.behaviour.transition("wakeup");
    }
  }

  takeTurn(stage) {
    //this.behaviour.execute(this.owner, stage);
    return true;
  }
}

class Bystander extends Entity {
  constructor(id, glyph, speed, quips) {
    super(null, null, glyph, id, {
      mass: new Mass(Mass.Medium),
      speed: new Speed(speed),
      health: new Health(1),
      quips: new Quips(quips),
      sense: new BystanderSense(90, 90)
    });
  }

  get description() {
    return this.quips.lookDescription();
  }

  canTakeTurn() {
    return false;
  }

  takeTurn(stage) {
    return true;
  }

  bumpFrom(entity, stage) {
    if (entity.isPlayer()) {
      entity.social.meeting(this.name);

      document.dispatchEvent(new CustomEvent("ui.transition", {
        detail: {
          command: "ShowQuip",
          description: this.quips.bumpDescription()
        }
      }));
      this.sense.wasBumped(stage);
    }
    // We don't currently handle bumps from other entities
    // but we should
  }
}

export default Bystander;